import { Injectable } from "@angular/core";
export type Store = 'local' | 'session';
@Injectable({
    providedIn: 'root'
})
export class BrowserStorageService {
    constructor() {

    }
    @catchError('set')
    set(key: any, value: any, store: Store = 'local'): any | void {
        if (store === 'local') {
            localStorage.setItem(key, value);
        } else {
            sessionStorage.setItem(key, value);
        }
    }
    @catchError('get')
    get(key: any, store: Store = 'local'): any {
        return (store === 'local') ? localStorage.getItem(key) : sessionStorage.getItem(key);
    }
    @catchError('remove')
    remove(key: string, store: Store = 'local'): void | any {
        if (store === 'local') {
            localStorage.removeItem(key);
        } else {
            sessionStorage.removeItem(key);
        }
    }
    @catchError('clear')
    clear(store: Store = 'local'): void | any {
        if (store === 'local') {
            localStorage.clear()
        } else {
            sessionStorage.clear()
        }
    }

    @catchError('clearAll')
    clearAll(): void | any {
            localStorage.clear();
            sessionStorage.clear();
    }


}
export function catchError(methodSingature: string) {
    return (target: any, propertyName: any, descriptor: any) => {
        const method = descriptor.value;
        descriptor.value = (...args: any) => {
            try {
                return method.apply(target, args);
            } catch (error) {
                console.warn('BrowserStorageService.' + methodSingature, error);
            }
        };
        return descriptor;
    }
}